<template>
  <div class="main">
    <admin-creator v-on:refresh="getAdmins()" />
    <div class="main-thing">
      <h5>Адміни</h5>
      <b-list-group v-for="admin in admins" :key="admin.id">
        <b-list-group-item>{{ admin.name }}</b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>

<script>
import AdminCreator from "@/components/modals/AdminCreator";
import { mapActions } from "vuex";
var axios = require("axios");
export default {
  name: "AdminList",
  components: {
    AdminCreator,
  },
  data: function () {
    return {
      admins: null,
    };
  },
  async mounted() {
    await this.getAdmins();
  },
  methods: {
    ...mapActions(["logOutUser"]),
    async getAdmins() {
      await axios
        .get(`${process.env.VUE_APP_API}/admin/all`, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .then((response) => {
          this.admins = response.data["List"];
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
    },
  },
};
</script>

<style scoped>
.main {
  margin-left: auto;
  margin-right: auto;
}
.main-thing {
  margin-top: 10px;
}
</style>
